import React from "react";

import "../../styles/app.css";

type Theme = "light" | "dark";
type Brand = "OverDrive" | "Libby" | "Sora" | "Lightning";

interface ShiftUiRootProps {
  children: React.ReactNode;
  theme: Theme;
  brand: Brand;
  dyslexic?: boolean;
}

const ShiftUiRoot: React.FC<ShiftUiRootProps> = ({
  children,
  theme,
  brand,
  dyslexic = false,
}: ShiftUiRootProps) => {
  return (
    <div
      className="shiftUiRoot"
      data-theme={theme}
      data-brand={brand}
      data-dyslexic={dyslexic === true ? "true" : "false"}
    >
      {children}
    </div>
  );
};

export { ShiftUiRoot };
